import type { BadgeProps } from './Badge.typed';
import * as Styled from './Badge.styled';

export const Badge = (props: BadgeProps) => {
  const { children, style } = props;
  return <Styled.Badge style={style}>{children}</Styled.Badge>;
};

export default Badge;
